const CALCULATOR_TYPES = ["BASIC", "SCIENTIFIC", "GRAPHING"] as const;
const TI_CALCULATOR_TYPES = ["ti108", "ti30mv", "ti84p"] as const;

export type CalculatorType = (typeof CALCULATOR_TYPES)[number];
export type TICalculatorType = (typeof TI_CALCULATOR_TYPES)[number];

export const validateSupportedCalculatorType = (
  calculatorType: string | undefined,
): CalculatorType | undefined => {
  if (
    calculatorType &&
    CALCULATOR_TYPES.includes(calculatorType as CalculatorType)
  ) {
    return calculatorType as CalculatorType;
  }
  return undefined;
};

export const calculatorTypeToTI: {
  [key in CalculatorType]: TICalculatorType;
} = {
  BASIC: "ti108",
  SCIENTIFIC: "ti30mv",
  GRAPHING: "ti84p",
};
